import { IStr } from '@/store/types';
import { CreateMenu, DeepFilter, IMenuItem } from './types';
import platformMenu from './data-platform';
import enterpriseMenu from './data-enterprise';

// 过滤权限并去重
function filterAuth(authList: IStr[]) {
  let result: IStr[] = [];
  authList.some((item) => {
    // 如果数组里任意一个为 null 则停止遍历并立即返回一个 [null] 数组, 否则添加并去重
    // 原因: [null]表示该菜单永久可见. 如果子菜单里任意一个永久可见，则父菜单也必须无条件永久可见
    // 之所以不用[]表示永久可见, 是因为父菜单上不设权限(用空数组表示)，而是递归合并所有子菜单上的权限
    const isNull = item === null;
    const isRepeat = result.indexOf(item) !== -1;
    result = isNull ? [null] : (isRepeat ? result : [...result, item]);
    return isNull;
  });
  return result;
}

// 递归合并子菜单上的权限(父菜单上的权限是由子菜单决定的，所以父菜单上没有设置权限, 需要递归合并子菜单上的权限)
function mergeAuth(node: IMenuItem) {
  // 深拷贝节点来防止修改源数据
  const newNode = { ...node, auth: node.auth ? [...node.auth] : [] };
  if (newNode.children) {
    newNode.children = newNode.children.map((child) => mergeAuth(child));
    newNode.auth = newNode.children.reduce((acc, child) => acc.concat(child.auth!), newNode.auth);
    newNode.auth = filterAuth(newNode.auth);  // 过滤并去重
  }
  return newNode;
}

// 根据当前节点上的过滤规则筛选节点(递归过滤)
const deepFilter: DeepFilter = (node, conditions) => {
  const fnResult = typeof node.rule === 'function' ? node.rule(node, conditions) : false;
  const newNode = fnResult ? { ...node } : null;
  if (newNode?.children) {
    newNode.children = newNode.children
      .map((child) => deepFilter(child, conditions))
      .filter(Boolean) as IMenuItem[];
  }
  return newNode;
};

// 生成主菜单
const createMenu: CreateMenu = (orgInfo, userInfo, userAuth, userModules) => {
  const isPlatformUser = userInfo.orgType === 0; // 是否是平台用户
  const menuData = isPlatformUser ? platformMenu : enterpriseMenu; // 根据用户类型选择菜单数据
  const conditions = { orgInfo, userInfo, userAuth, userModules };
  return menuData
    .map((menu) => mergeAuth(menu))               // 将子孙节点上的权限合并到祖先节点上
    .map((menu) => deepFilter(menu, conditions))  // 根据节点上定义的 rule 函数过滤节点
    .filter(Boolean) as IMenuItem[];
};

export default createMenu;
